export default {"src":"/_next/static/media/bone.d5abd823.svg","height":165,"width":102,"blurWidth":0,"blurHeight":0};